module.exports = __webpack_public_path__ + "img/realizzazione 2.c5a11822.gif";